import React, { useCallback, useMemo } from 'react';
import propTypes from 'prop-types';
import { Tooltip } from 'antd';

import style from './index.less';

function StatisticsBar({ count = 0, title = '', other = 0 }) {

  const height = useMemo(() => {
    if ((count === 0 && other === 0) || count === 0) {
      return 2;
    }
    // 当前的大于其他的，当前的就是顶点
    if (count >= other) {
      return 100;
    }
    return 100 * (count / other);
  }, [count, other]);

  const getPopupContainer = useCallback(e => {
    return e.parentElement;
  }, []);

  return (
    <div className={style.bar}>
      <Tooltip
        title={<div className={style.center}>{`${count}`}</div>}
        getPopupContainer={getPopupContainer}
        open={true}>
        <div style={{ height }} className={style.bar_center} />
      </Tooltip>
      <div className={style.title}>{title}</div>
    </div>
  );
}

StatisticsBar.propTypes = {
  count: propTypes.number,
  title: propTypes.string,
  other: propTypes.number
};

export default StatisticsBar;
